<div class="pagina-kaart">
	<span class="titel">{{ weergaveTitel() }}</span>
	@if (filteringTekst()) {
		<span class="filtering">{{ filteringTekst() }}</span>
	}
	@if (hoofdpagina()) {
		<span class="tag">{{ hoofdpagina() }}</span>
	}
</div>
